module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/Item/images/hover.23aa01f3.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/Item/images/hover.png
// module id = 3069
// module chunks = 11